import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../lib/api';

export const login = createAsyncThunk('auth/login', async (creds, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/login/', creds, {
      headers: { 'Content-Type': 'application/json', 'X-Bypass-Auth': '1' },
    });
    localStorage.setItem('access', data.access);
    localStorage.setItem('refresh', data.refresh);
    return data;
  } catch (e) {
    return rejectWithValue(e.response?.data?.error || 'Login failed');
  }
});

export const fetchMe = createAsyncThunk('auth/fetchMe', async (_, { rejectWithValue }) => {
  try {
    const access = localStorage.getItem('access');
    if (!access) return rejectWithValue('No token');
    const { data } = await api.get('/accounts/me/');
    return data;
  } catch (e) {
    return rejectWithValue('Failed to load profile');
  }
});

const initialState = {
  token: localStorage.getItem('access') || null,
  refresh: localStorage.getItem('refresh') || null,
  username: null,
  is_staff: false,
  is_superuser: false,
  is_admin: false,
  initialized: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      state.token = null;
      state.refresh = null;
      state.username = null;
      state.is_staff = false;
      state.is_superuser = false;
      state.is_admin = false;
      state.initialized = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(login.fulfilled, (s, { payload }) => {
        s.loading = false;
        s.token = payload.access;
        s.refresh = payload.refresh;
        const u = payload.user || {};
        s.username = u.username || null;
        s.is_staff = !!u.is_staff;
        s.is_superuser = !!u.is_superuser;
        s.is_admin = !!u.is_staff || !!u.is_superuser;
        s.initialized = true;
      })
      .addCase(login.rejected, (s, { payload }) => {
        s.loading = false; s.error = payload || 'Login failed';
        s.initialized = true;
      })
      .addCase(fetchMe.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchMe.fulfilled, (s, { payload }) => {
        s.loading = false;
        s.username = payload.username || s.username;
        s.is_staff = !!payload.is_staff;
        s.is_superuser = !!payload.is_superuser;
        s.is_admin = !!payload.is_staff || !!payload.is_superuser;
        s.initialized = true;
      })
      .addCase(fetchMe.rejected, (s) => {
        s.loading = false;
        s.initialized = true;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
